let config = null;
let loadingPromise = null;

export async function loadConfig() {
  if (config) {
    return config;
  }

  // If already loading, return the existing promise
  if (loadingPromise) {
    return loadingPromise;
  }

  loadingPromise = (async () => {
    try {
      // Use import.meta.env.BASE_URL to respect Vite's base path configuration
      const configPath = `${import.meta.env.BASE_URL}config.json`;
      const response = await fetch(configPath);
      config = await response.json();
      return config;
    } catch (error) {
      console.error("Failed to load config.json:", error);
      // Fallback to empty string (relative URLs)
      config = { API_BASE_URL: "" };
      return config;
    } finally {
      loadingPromise = null;
    }
  })();

  return loadingPromise;
}

export function getApiBaseUrl() {
  return config?.API_BASE_URL || "";
}

export function getApiAuth() {
  return config?.API_AUTH || "";
}

export function getApiDashboardUrl() {
  return config?.API_DASHBOARD_URL || "";
}

export function getApiIotBaseUrl() {
  return config?.API_IOT_BASE_URL || "";
}

export function getConfig() {
  return config;
}
